import React from 'react';
import divider from '../../assets/divider-img.png';
import icon1 from '../../assets/hs1.png';
import icon2 from '../../assets/hs2.png';
import icon3 from '../../assets/hs3.png';
import { AiOutlineRight } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const HomeServices = () => {
  return (
    <div className="home-services">
      <div className="container">
        <div className="section-top">
          <h2>Services</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            We offer a range of specialized financial solutions designed to
            empower your success in today's ever-evolving financial markets.
          </p>
        </div>
        <div className="services-wrapper">
          <Link to="/services/algo-trading">
            <div className="service-item home-service-item">
              <div className="service-icon">
                <img src={icon1} alt="services icon" />
              </div>
              <h3>Algorithmic Trading</h3>
              <p>
                Our advanced algorithms execute trades with precision,
                leveraging data-driven strategies to optimize your investment
                decisions. Let us navigate the markets for you with efficiency
                and accuracy.
              </p>
              <div className="veiw-dets">
                <h5>Veiw Details</h5>
                <AiOutlineRight />
              </div>
            </div>
          </Link>
          <Link to="/services/backtesting">
            <div className="service-item m-lr home-service-item">
              <div className="service-icon">
                <img src={icon2} alt="services icon" />
              </div>

              <h3>Backtest</h3>
              <p>
                We rigorously test trading strategies against historical data to
                assess their viability and performance. Backtesting with
                Quantome ensures you make informed decisions based on solid
                historical analysis.
              </p>
              <div className="veiw-dets">
                <h5>Veiw Details</h5>
                <AiOutlineRight />
              </div>
            </div>
          </Link>

          <Link to="/services/customised-solution">
            <div className="service-item home-service-item">
              <div className="service-icon">
                <img src={icon3} alt="services icon" />
              </div>

              <h3>Customised Solutions</h3>
              <p>
                Tailored to your unique needs, our customized financial
                solutions provide a personalized approach to address your
                specific challenges. Whether it’s strategy development, risk
                management, automation, investment advisory, portfolio
                management we design solutions that work for you.
              </p>
              <div className="veiw-dets">
                <h5>Veiw Details</h5>
                <AiOutlineRight />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeServices;
